//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaTableViews', {
//        templateUrl: 'views/components/views/metaTableViews/metaTableViews.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'metaTableViewsService', function ($stateParams, stateService, metaTableViewsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let metaTableKeyno = $stateParams.metatable_keyno;

//            vm.model = {
//                itemsListMetaTableViews: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadMetaTableViews() {
//                vm.model.itemsListMetaTableViews = await metaTableViewsService.listMetaTableViews({ metatable_keyno: metaTableKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'metatableview':
//                        go({
//                            metatable_keyno: metaTableKeyno,
//                            metatableview_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMetaTableViews();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
